module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-big.821fdd4d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-big.png
// module id = 2930
// module chunks = 11